import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Verify from "@/pages/Verify";
import CertificateDemo from "@/pages/CertificateDemo";
import Services from "@/pages/Services";
import ForIndustry from "@/pages/ForIndustry";
import ForBuyers from "@/pages/ForBuyers";
import BotswanaJourney from "@/pages/BotswanaJourney";
import TrustGovernance from "@/pages/TrustGovernance";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Portal from "@/pages/Portal";
import SubmitDiamond from "@/pages/SubmitDiamond";
import DiamondDetail from "@/pages/DiamondDetail";
import Legal from "@/pages/Legal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/certificate" element={<CertificateDemo />} />
            <Route path="/services" element={<Services />} />
            <Route path="/industry" element={<ForIndustry />} />
            <Route path="/buyers" element={<ForBuyers />} />
            <Route path="/journey" element={<BotswanaJourney />} />
            <Route path="/trust" element={<TrustGovernance />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal/:slug" element={<Legal />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/portal" element={<ProtectedRoute><Portal /></ProtectedRoute>} />
            <Route path="/portal/submit" element={<ProtectedRoute><SubmitDiamond /></ProtectedRoute>} />
            <Route path="/portal/diamond/:id" element={<ProtectedRoute><DiamondDetail /></ProtectedRoute>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
